export const common = {
  // Navigation
  'nav.features': '기능',
  'nav.howItWorks': '작동 방식',
  'nav.pricing': '가격',
  'nav.faq': '자주 묻는 질문',
  'nav.aboutUs': '회사 소개',
  'nav.getStarted': '시작하기',

  // About Us Section
  'aboutUs.badge': "회사 소개",
  'aboutUs.title': "IdeaVerdict가 존재하는 이유",
  'aboutUs.line1': "아이디어는 누구나 가진다.",
  'aboutUs.line2': "자기 아이디어가 통하지 않는다고 인정하는 사람은 드물다.",
  'aboutUs.paragraph1':
    "대부분의 아이디어는 창업자에게 용기가 부족해서 실패하지 않는다. 누구도 충분히 빨리 진실을 말해주지 않아서 실패한다. IdeaVerdict는 그 공백을 메운다 ― 친구들이 말하지 않는 냉정한 평가를 우리가 한다.",
  'aboutUs.belief1a': "과장은 다루지 않는다.",
  'aboutUs.belief1b': "시장 신호만 다룬다.",
  'aboutUs.belief2a': "동기 부여를 팔지 않는다.",
  'aboutUs.belief2b': "수요, 경쟁, 실현 가능성에 대한 명확한 판독을 판다.",
  'aboutUs.mission1': "우리 일은 당신의 아이디어를 좋아 보이게 하는 게 아니다.",
  'aboutUs.mission2': "실제로 좋은지 말해주는 것이다.",
  'aboutUs.analysis':
    "IdeaVerdict는 결정적인 요소로 아이디어를 평가한다 ― 시장 구조, 실수요, 경쟁, 필요 자본, 매출까지의 시간, 확장성. 감정 없음. 낙관 없음. 분석뿐.",
  'aboutUs.failure1': "대부분의 사업은 실패한다.",
  'aboutUs.failure2': "뒤에 있는 사람들이 무능해서가 아니라 ―",
  'aboutUs.failure3': "누구도 충분히 빨리, 충분히 강하게 반박하지 않아서다.",
  'aboutUs.clarity': "우리는 반박하기 위해 존재한다.",
  'aboutUs.value1': "직설적.",
  'aboutUs.value2': "솔직.",
  'aboutUs.value3': "신속.",
  'aboutUs.confirm': "아이디어에 실체가 있다면, 밀어준다.",
  'aboutUs.deny': "없다면, 면전에서 그렇게 말한다.",
  'aboutUs.noApplause': "박수 없음.",
  'aboutUs.noSugarcoating': "미사여구 없음.",
  'aboutUs.noTheater': "연극 없음.",
  'aboutUs.noHype': "판결뿐.",
  // Hero Section
  'hero.badge': '60초 이내 AI 판결',
  'hero.title1': '확인하지 않고',
  'hero.title2': '만들지 마세요.',
  'hero.subtitle': 'IdeaVerdict는 회의적인 VC처럼 당신의 아이디어를 시험합니다.',
  'hero.subtitleLine2': '몇 초 만에 정직한 판결 — 과장도, 아첨도 없이.',
  'hero.cta': '내 판결 받기',
  'hero.ctaSecondary': '작동 방식 보기',
  'hero.stat1Value': '30',
  'hero.stat1Label': '요청당 크레딧',
  'hero.stat2Value': '7개+',
  'hero.stat2Label': '평가 차원',
  'hero.stat3Value': '100%',
  'hero.stat3Label': '정직함 및 비공개',

  // Features Section
  'features.title1': '진실을 원하는',
  'features.title2': '창업자를',
  'features.title3': '위해',
  'features.bullet1.title': '몇 초 안에 솔직한 판정',
  'features.bullet1.description':
    '강함, 보통, 약함 — 각 평가의 근거와 함께. 박수도, 미화도, 연극도 없습니다.',
  'features.bullet2.title': '정말 중요한 기준으로 평가',
  'features.bullet2.description':
    '당신의 아이디어는 실제 수요, 경쟁, 필요 자본, 수익화 시간, 확장성으로 평가됩니다 — 분위기가 아니라.',
  'features.bullet3.title': '판정에서 실제 빌드까지',
  'features.bullet3.description':
    'Builder 모드는 통과된 아이디어를 개발자 브리핑으로 바꿉니다: 사용자 흐름, 핵심 기능, 기술 메모.',

  // How It Works
  'howItWorks.title': '작동 방식',
  'howItWorks.subtitle': '비즈니스 틈새 시장에 대한 명확성을 얻는 4단계',
  'howItWorks.step1Title': '플랜 선택',
  'howItWorks.step1Desc': '스타터, 프로 또는 빌더 – 리뷰 깊이에 따라 선택하세요.',
  'howItWorks.step2Title': 'AI에게 질문',
  'howItWorks.step2Desc': '틈새 시장에 대한 질문을 하세요. 각 요청은 30크레딧이 소요됩니다.',
  'howItWorks.step3Title': '정직한 평가 받기',
  'howItWorks.step3Desc': 'AI가 평가합니다: 좋음, 보통, 나쁨. 포장이 없습니다.',
  'howItWorks.step4Title': '결정하기',
  'howItWorks.step4Desc': '이제 진행할 가치가 있는지 알 수 있습니다.',

  // Pricing
  'pricing.title': '가격',
  'pricing.subtitle': '리뷰 깊이에 맞는 플랜을 선택하세요.',
  'pricing.monthly': '월간',
  'pricing.yearly': '연간',
  'pricing.yearlyDiscount': '연간 구독:',
  'pricing.yearlyDiscountValue': '-20% 할인',
  'pricing.perMonth': '/월',
  'pricing.selectPlan': '플랜 선택',
  'pricing.mostPopular': '가장 인기 있는',
  'pricing.footer':
    '모든 가격은 CHF입니다. 크레딧은 성공적인 AI 응답에 대해서만 차감됩니다.',

  
  // Pricing Features
  'pricing.feature1': '무료 채팅 (양식 없음)',
  'pricing.feature2': '시장 논리 및 정직한 평가',
  'pricing.feature3': '지속적인 채팅 기록',
  'pricing.feature4': '다중 병렬 채팅 세션',
  'pricing.feature5': '완전한 다국어 지원',
  'pricing.feature6': '크레딧 기반 이용',
  'pricing.feature7': '월간 초기화',
  'pricing.feature8': '시장 분석',
  'pricing.feature9': '요약',
  'pricing.feature10': '강점',
  'pricing.feature11': '약점',
  'pricing.feature12': '기회',
  'pricing.feature13': '위험',
  'pricing.feature14': '권장 사항',
  'pricing.feature15': 'PDF 다운로드',
  'pricing.feature16': '개발자 브리핑 없음',
  'pricing.feature17': '빌더 모드: 개발자 브리핑',
  'pricing.feature18': '구조화된 요약',

  // Starter Plan
  'pricing.starter.name': '스타터',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'AI 틈새 챗봇 이용 가능',
  'pricing.starter.credits': '월 2,500 크레딧',
  'pricing.starter.feature1': '틈새 아이디어 생성',
  'pricing.starter.feature2': '틈새 시장 개선',
  'pricing.starter.feature3': '시장 현실 점검',
  'pricing.starter.feature4': '경쟁 평가',
  'pricing.starter.feature5': '시간 평가',
  'pricing.starter.feature6': '정직한 평가',
  'pricing.starter.feature7': '비공개 세션',
  'pricing.starter.feature8': '기록 및 내보내기',

  // Pro Plan
  'pricing.pro.name': '프로',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'AI 틈새 챗봇 이용 가능',
  'pricing.pro.credits': '월 5,000 크레딧',
  'pricing.pro.feature1': '모든 스타터 기능',
  'pricing.pro.feature2': '집중 리뷰를 위한 더 많은 크레딧',
  'pricing.pro.feature3': '개선 제안',
  'pricing.pro.feature4': '대체 틈새 시장',
  'pricing.pro.feature5': '상세 시장 분석',
  'pricing.pro.feature6': '우선 지원',
  'pricing.pro.feature7': '고급 필터',
  'pricing.pro.feature8': '세션 즐겨찾기',

  // Builder Plan
  'pricing.builder.name': "빌더",
  'pricing.builder.price': '199',
  'pricing.builder.description': "전체 기능 + 빌더 모드",
  'pricing.builder.credits': "월 10,000 크레딧",
  'pricing.builder.feature1': '모든 프로 기능',
  'pricing.builder.feature2': '무제한 AI 요청',
  'pricing.builder.feature3': '빌더 모드: 개발자 브리핑',
  'pricing.builder.feature4': '구조화된 프로젝트 개요',
  'pricing.builder.feature5': '사용자 흐름 및 핵심 기능',
  'pricing.builder.feature6': '기술 노트',
  'pricing.builder.feature7': '비목표 정의',
  'pricing.builder.feature8': '공정 사용 속도 제한',
  'pricing.builder.limitNote': '공정 사용 제한',
  'pricing.monthlyReset': '월간 초기화',

  // Modal
  'pricing.modal.selected': '선택됨',
  'pricing.modal.comingSoon':
    '등록 및 결제 처리는 곧 가능해집니다.',
  'pricing.modal.patience':
    '안전하고 원활한 경험을 제공하기 위해 노력하고 있습니다. 양해 부탁드립니다.',
  'pricing.modal.understood': '확인',

  // FAQ
  'faq.title': '자주 묻는 질문',
  'faq.subtitle': '정직하고 비판적으로 답변합니다.',
  'faq.q1': "IdeaVerdict는 실제로 뭘 하나?",
  'faq.a1': "결과를 가르는 요소로 아이디어를 평가한다 ― 실수요, 경쟁, 필요 자본, 시장 진입 시간, 확장성.\n통한다면, 다듬는 법을 보여준다.\n안 통한다면, 그것도 말한다.",
  'faq.q2': "아이디어도 만들어 주나?",
  'faq.a2': "한다 ― 다만 모자에서 무작위로 꺼내는 식은 아니다.\n아이디어는 이번 주 유행이 아니라 실제 시장의 빈틈에서 나온다.",
  'faq.q3': "기존 사업 모델도 개선해 주나?",
  'faq.a3': "개선할 게 있다면 한다.\n망가진 아이디어를 광내지 않는다 ― 이미 토대가 있는 것만 강화한다.",
  'faq.q4': "다른 AI 도구와 뭐가 다른가?",
  'faq.a4': "대부분의 AI 도구는 당신의 아이디어가 훌륭하다고 말한다.\n우리는 실제로 그런지 말한다.\n차이는 열광이 아니라 현실주의.",
  'faq.q5': "성공을 보장하나?",
  'faq.a5': "아니.\n나쁜 베팅을 피하게 돕는다 ― 리스크는 사라지지 않지만, 눈을 뜨고 들어가게 된다.",
  'faq.q6': "IdeaVerdict는 누구를 위한 것인가?",
  'faq.a6': "론칭 전의 창업자.\n주말 프로젝트 전의 빌더.\n다음 베팅을 앞둔 운영자.\n서명 전의 투자자.\n\n결정 전에 명확함을 원하는 모두를 위해.",
  'faq.q7': "그냥 인정받고 싶다면?",
  'faq.a7': "그러면 IdeaVerdict는 잘못된 도구다.\n우리는 솔직한 판독을 제공한다, 안심이 아니다.",
  'faq.q8': "분석은 정말 얼마나 솔직한가?",
  'faq.a8': "데이터가 허용하는 만큼 솔직하다.\n감정을 다치게 하지 않으려고 약한 판결을 부드럽게 만들지 않는다.",
  'faq.q9': "진짜 시장 조사를 대체하나?",
  'faq.a9': "아니.\n투자 전 빠른 전략 점검이다 ― 50페이지짜리 시장 보고서가 아니다.",
  'faq.q10': "왜 그렇게 직설적인가?",
  'faq.a10': "잘못된 걸 만들면 몇 달을 잃기 때문이다.\n솔직한 판결은 몇 분이면 된다.\n\n우리는 그 몇 분을 택한다.",
  // Footer
  'footer.description':
    'IdeaVerdict는 당신을 기분 좋게 하기 위해 있는 것이 아닙니다. 올바른 결정을 돕기 위해 있습니다.',
  'footer.product': '제품',
  'footer.aiAssistant': 'AI 어시스턴트',
  'footer.howItWorks': '작동 방식',
  'footer.pricing': '가격',
  'footer.faq': '자주 묻는 질문',
  'footer.legal': '법적 고지',
  'footer.privacy': '개인정보처리방침',
  'footer.terms': '이용약관',
  'footer.imprint': '사업자 정보',
  'footer.support': '지원',
  'footer.contact': '문의',
  'footer.documentation': '문서',
  'footer.copyright': '© 2026 IdeaVerdict. 모든 권리 보유.',

  // AI Assistant
  'aiAssistant.title': 'AI 틈새 어시스턴트',
  'aiAssistant.subtitle': '틈새 시장에 대해 질문하세요',
  'aiAssistant.welcomeMessage':
    '안녕하세요! 아이디어를 설명하거나 틈새 시장에 대해 물어보세요. 명확하고 정직한 평가를 해드리겠습니다.',
  'aiAssistant.demoResponse':
    '데모입니다. 실제 AI 평가를 받으시려면 등록하고 플랜을 선택하세요.',
  'aiAssistant.placeholder': '아이디어를 설명하세요...',

  // Header & Sidebar
  'dashboard.header.title': '대시보드',
  'dashboard.header.aiAssistant': 'AI 어시스턴트',
  'header.logout': '로그아웃',
  'dashboard.sidebar.overview': '개요',
  'dashboard.sidebar.aiChat': 'AI 어시스턴트',
  'dashboard.sidebar.newAnalysis': 'AI 어시스턴트',
  'dashboard.sidebar.history': '기록',
  'dashboard.sidebar.credits': '크레딧',
  'dashboard.sidebar.settings': '설정',

  // Dashboard Overview
  'dashboard.overview.welcome': '환영합니다, {{name}}님',
  'dashboard.overview.subtitle':
    '활동에 대한 빠른 개요입니다',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': '남은 크레딧',
  'dashboard.stats.totalAnalyses': '총 분석 수',
  'dashboard.stats.goodRatings': '긍정 평가',
  'dashboard.stats.nextReset': '다음 초기화까지',
  'dashboard.stats.days': '일',

  // Quick Actions
  'dashboard.quickActions.title': '빠른 작업',
  'dashboard.quickActions.checkNewIdea': '아이디어 확인',
  'dashboard.quickActions.checkNewIdeaDesc':
    '기존 비즈니스 아이디어 분석',
  'dashboard.quickActions.generateIdea': '아이디어 생성',
  'dashboard.quickActions.generateIdeaDesc':
    '새로운 수익성 있는 틈새 시장 찾기',
  'dashboard.quickActions.builderBriefing': '빌더 브리핑',
  'dashboard.quickActions.builderBriefingDesc':
    '아이디어를 개발자용 브리핑으로 변환',
  'dashboard.quickActions.premiumOnly': '빌더 전용',

  // Chat Header
  'chat.title': 'AI 틈새 어시스턴트',
  'chat.subtitle':
    '틈새 시장에 대해 질문하세요. 비판적이고 정직하게 평가합니다.',
  'chat.creditsLabel': '크레딧',

  // Chat Welcome
  'chat.welcomeTitle': 'AI 틈새 어시스턴트에 오신 것을 환영합니다',
  'chat.welcomeDesc':
    '아이디어를 설명하거나 틈새 시장에 대해 물어보세요. 좋음, 보통, 나쁨으로 정직하게 평가합니다.',
  'chat.aiWelcome':
    '안녕하세요! 아이디어를 설명하거나 틈새 시장에 대해 물어보세요. 명확하고 정직한 평가를 해드리겠습니다.',

  // Chat Suggestions
  'chat.suggestion1': '프리랜서를 위한 인보이스 관리 SaaS 도구를 만들고 싶습니다. 좋은 틈새인가요?',
  'chat.suggestion2': '코딩 없이 $500으로 시작할 수 있는 경쟁이 적은 온라인 비즈니스를 찾아주세요.',
  'chat.suggestion3': '이것을 평가해주세요: 식이제한이 있는 바쁜 부모를 위한 AI 식단 계획 앱.',
  'chat.suggestion4': 'Etsy에서 소규모 사업자를 위한 디지털 템플릿을 판매하고 싶습니다. 이 틈새를 정직하게 분석해주세요.',

  // Chat Actions
  'chat.newConversation': '새 대화',
  'chat.today': '오늘',
  'chat.yesterday': '어제',
  'chat.thisWeek': '이번 주',
  'chat.thisMonth': '이번 달',
  'chat.older': '이전',
  'chat.messages': '개 메시지',
  'chat.renameConversation': '이름 바꾸기',
  'chat.deleteConversation': '삭제',
  'chat.cancel': '취소',
  'chat.rename': '이름 변경',
  'chat.delete': '삭제',
  'chat.favorite': '즐겨찾기 추가',
  'chat.unfavorite': '즐겨찾기 제거',
  'chat.searchSessions': '대화 검색...',
  'chat.noResults': '검색 결과가 없습니다',
  'chat.noSessions': '아직 대화가 없습니다',
  'chat.enterNewName': '새 이름 입력...',
  'chat.deleteConfirmMessage':
    '이 대화를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',

  // Chat Input & Errors
  'chat.inputPlaceholder': '질문을 입력하세요… (30 크레딧 소요)',
  'chat.send': '보내기',
  'chat.voice': '음성 입력',
  'chat.listeningPlaceholder': '듣고 있습니다... 지금 말씀하세요.',
  'chat.stopListening': '듣기 중지',
  'chat.recording': '녹음 중...',
  'chat.speechNotSupported': '브라우저가 음성 인식을 지원하지 않습니다.',
  'chat.microphonePermissionDenied': '마이크 접근이 거부되었습니다. 브라우저 설정에서 허용해주세요.',
  'chat.errorNotEnoughCredits':
    '크레딧이 부족합니다. 플랜을 업그레이드하거나 다음 초기화를 기다려주세요.',
  'chat.errorAiFailed': 'AI 응답에 실패했습니다. 크레딧이 차감되지 않았습니다.',
  'chat.errorRateLimit': '요청이 너무 많습니다. 잠시 기다려주세요.',

  // Ratings
  'rating.good': '좋음',
  'rating.medium': '보통',
  'rating.bad': '나쁨',

  // Auth Page
  'auth.branding.headline1': '모든 아이디어가 좋은 것은 아닙니다.',
  'auth.branding.headline2': '정직하게 알려드립니다.',
  'auth.branding.subtitle':
    '비즈니스 틈새 시장을 위한 의사 결정 AI. 명확함. 비판적. 포장 없음.',
  'auth.benefits.privacy.title': '100% 비공개',
  'auth.benefits.privacy.desc':
    '아이디어는 완전히 비공개로 안전하게 보호됩니다.',
  'auth.benefits.honest.title': '정직한 AI',
  'auth.benefits.honest.desc':
    '포장 없는 명확하고 비판적인 피드백',
  'auth.benefits.fast.title': '빠른 결과',
  'auth.benefits.fast.desc': '몇 분 만에 틈새 시장에 대한 명확성 확보',
  'auth.trust.users': '활성 사용자',
  'auth.trust.ideas': '분석된 아이디어',
  'auth.trust.rating': '사용자 평점',
  'auth.login.title': '로그인',
  'auth.login.headline': '다시 오신 것을 환영합니다',
  'auth.login.subtitle': '계속하려면 로그인하세요.',
  'auth.login.forgotPassword': '비밀번호를 잊으셨나요?',
  'auth.login.submit': '로그인',
  'auth.login.noAccount': '계정이 없으신가요?',
  'auth.login.signUp': '회원가입',
  'auth.register.title': '회원가입',
  'auth.register.headline': '계정 만들기',
  'auth.register.subtitle':
    '오늘부터 비즈니스 아이디어를 분석해보세요.',
  'auth.register.submit': '계정 만들기',
  'auth.register.hasAccount': '이미 계정이 있으신가요?',
  'auth.register.signIn': '로그인',
  'auth.fields.name': '이름',
  'auth.fields.email': '이메일 주소',
  'auth.fields.password': '비밀번호',
  'auth.fields.confirmPassword': '비밀번호 확인',
  'auth.fields.selectPlan': '플랜 선택',
  'auth.fields.testCode': '로그인 및 무료 테스트',
  'auth.placeholders.name': '이름 입력',
  'auth.placeholders.email': '이메일 입력',
  'auth.placeholders.password': '비밀번호 입력',
  'auth.placeholders.confirmPassword': '비밀번호 확인',
  'auth.placeholders.testCode': '테스트 코드 입력',
  'auth.terms.accept': '동의합니다',
  'auth.terms.terms': '이용약관',
  'auth.privacy.accept': '동의합니다',
  'auth.privacy.policy': '개인정보처리방침',
  'auth.errors.nameRequired': '이름은 필수입니다',
  'auth.errors.emailRequired': '이메일은 필수입니다',
  'auth.errors.emailInvalid': '유효한 이메일을 입력해주세요',
  'auth.errors.passwordRequired': '비밀번호는 필수입니다',
  'auth.errors.passwordLength': '비밀번호는 최소 8자 이상이어야 합니다',
  'auth.errors.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'auth.errors.invalidCode': '유효하지 않거나 만료된 코드입니다',
  'auth.errors.registrationCodeOnly': '이 코드는 등록 전용입니다',
  'auth.errors.verificationFailed': '코드 확인 중 오류가 발생했습니다. 다시 시도해주세요.',
  'auth.loading': '잠시 기다려주세요...',
  'auth.or': '또는 다음으로 계속',
  'auth.social.google': 'Google로 계속',
  'auth.social.apple': 'Apple로 계속',
  'auth.actions.verify': '확인',
  'auth.testCode.activated': '테스트 코드가 활성화되었습니다!',
  'auth.testCode.days': '일',
  'auth.testCode.months': '개월',
  'auth.testCode.freeAccess': '무료 이용',
  'auth.testCode.credits': '크레딧',

  // Email Verification
  'auth.verification.title': '이메일 확인',
  'auth.verification.headline': '받은 편지함을 확인하세요',
  'auth.verification.subtitle': '다음 주소로 인증 코드를 보냈습니다:',
  'auth.verification.codeLabel': '인증 코드',
  'auth.verification.codePlaceholder': '6자리 코드 입력',
  'auth.verification.submit': '이메일 확인',
  'auth.verification.resend': '코드 다시 보내기',
  'auth.verification.resendIn': '다시 보내기까지',
  'auth.verification.seconds': '초',
  'auth.verification.success': '이메일이 성공적으로 확인되었습니다!',
  'auth.verification.error': '잘못된 코드입니다. 다시 시도해주세요.',
  'auth.verification.expired': '코드가 만료되었습니다. 새 코드를 요청해주세요.',
  'auth.verification.sent': '새 코드가 전송되었습니다!',
  'auth.verification.checkSpam':
    '받지 못하셨나요? 스팸 폴더를 확인해보세요.',

  // Forgot Password
  'auth.forgot.title': '비밀번호 찾기',
  'auth.forgot.headline': '비밀번호 재설정',
  'auth.forgot.subtitle':
    '이메일 주소를 입력하시면 재설정 링크를 보내드립니다.',
  'auth.forgot.submit': '재설정 링크 보내기',
  'auth.forgot.backToLogin': '로그인으로 돌아가기',
  'auth.forgot.success': '이메일이 전송되었습니다!',
  'auth.forgot.successMessage':
    '비밀번호 재설정 안내 이메일을 보내드렸습니다.',
  'auth.forgot.checkInbox': '받은 편지함을 확인하세요',

  // Reset Password
  'auth.reset.title': '새 비밀번호',
  'auth.reset.headline': '새 비밀번호 설정',
  'auth.reset.subtitle': '새 비밀번호를 입력하세요.',
  'auth.reset.newPassword': '새 비밀번호',
  'auth.reset.confirmNewPassword': '새 비밀번호 확인',
  'auth.reset.submit': '비밀번호 변경',
  'auth.reset.success': '비밀번호가 성공적으로 변경되었습니다!',
  'auth.reset.successMessage':
    '이제 새 비밀번호로 로그인할 수 있습니다.',
  'auth.reset.loginNow': '지금 로그인',

  // Legal Pages
  'legal.backToAuth': '로그인으로 돌아가기',
  'legal.allRightsReserved': '모든 권리 보유.',

  // Terms Page
  'legal.terms.title': '이용약관',
  'legal.terms.lastUpdated': '최종 업데이트',
  'legal.terms.section1.title': '1. 적용 범위',
  'legal.terms.section1.content':
    '본 이용약관은 NicheFinder(이하 "제공자")와 사용자(이하 "고객") 간의 AI 기반 틈새 분석 플랫폼 사용에 관한 모든 계약에 적용됩니다.',
  'legal.terms.section2.title': '2. 서비스 설명',
  'legal.terms.section2.content':
    '제공자는 비즈니스 아이디어와 틈새 시장을 분석하고 평가하는 AI 기반 플랫폼을 제공합니다. 서비스에는 다음이 포함됩니다:',
  'legal.terms.section2.item1': '비즈니스 아이디어의 AI 기반 분석',
  'legal.terms.section2.item2': '시장 잠재력 및 경쟁 평가',
  'legal.terms.section2.item3': '틈새 제안 생성',
  'legal.terms.section2.item4': '개발자 브리핑 생성(빌더 패키지)',
  'legal.terms.section3.title': '3. 계약 체결 및 등록',
  'legal.terms.section3.content':
    '계약은 플랫폼에 등록하고 패키지를 선택함으로써 체결됩니다. 고객은 다음을 확인합니다:',
  'legal.terms.section3.item1': '법적 연령이며 완전한 법적 능력을 갖춘 자',
  'legal.terms.section3.item2': '등록 시 정확한 정보 제공',
  'legal.terms.section3.item3': '액세스 자격 증명의 안전한 보관',
  'legal.terms.section4.title': '4. 크레딧 및 결제',
  'legal.terms.section4.content':
    'AI 기능 사용은 크레딧 시스템을 기반으로 합니다. 각 AI 쿼리는 30크레딧이 소요됩니다. 크레딧은 성공적인 응답 시에만 차감됩니다. 사용하지 않은 크레딧은 청구 기간 말에 만료되며 환불되지 않습니다.',
  'legal.terms.section5.title': '5. 면책 조항',
  'legal.terms.section5.content':
    'AI 평가는 의사 결정 보조 도구로만 제공되며 비즈니스 성공을 보장하지 않습니다. 제공자는 AI 분석을 기반으로 한 결정에 대해 책임을 지지 않습니다. 고의 및 중대한 과실에 대한 책임은 영향을 받지 않습니다.',
  'legal.terms.section6.title': '6. 데이터 보호 및 기밀 유지',
  'legal.terms.section6.content':
    '제출된 모든 비즈니스 아이디어는 기밀로 처리되며 제3자와 공유되지 않습니다. 개인 데이터 처리는 개인정보처리방침 및 해당 데이터 보호 법률에 따라 수행됩니다.',
  'legal.terms.section7.title': '7. 계약 해지',
  'legal.terms.section7.content':
    '고객은 언제든지 현재 청구 기간 말에 구독을 취소할 수 있습니다. 본 약관을 위반하는 경우 제공자는 플랫폼에 대한 액세스를 차단할 권리를 보유합니다.',
  'legal.terms.section8.title': '8. 최종 조항',
  'legal.terms.section8.content':
    '스위스 법이 적용됩니다. 관할 법원은 스위스 취리히입니다. 본 약관의 개별 조항이 무효인 경우 나머지 조항의 유효성은 영향을 받지 않습니다.',
  'legal.terms.contact.title': '이용약관에 대해 질문이 있으신가요?',
  'legal.terms.contact.content':
    '이용약관에 대해 질문이 있으시면 다음 주소로 문의해주세요:',

  // Privacy Page
  'legal.privacy.title': '개인정보처리방침',
  'legal.privacy.section1.title': '1. 데이터 책임자',
  'legal.privacy.section1.content':
    '이 웹사이트의 데이터 책임자는 스위스 취리히에 소재한 NicheFinder입니다. 당사는 귀하의 개인 데이터를 매우 중요하게 보호하며, 법정 데이터 보호 규정에 따라 귀하의 개인 데이터를 기밀로 처리합니다.',
  'legal.privacy.section2.title': '2. 수집하는 데이터',
  'legal.privacy.section2.content':
    '당사는 다음과 같은 개인 데이터를 수집하고 처리합니다:',
  'legal.privacy.section2.item1':
    '등록 데이터: 이름, 이메일 주소, 비밀번호(암호화됨)',
  'legal.privacy.section2.item2':
    '사용 데이터: IP 주소, 브라우저 유형, 접속 시간',
  'legal.privacy.section2.item3':
    '비즈니스 아이디어 및 틈새 쿼리(익명으로 저장)',
  'legal.privacy.section2.item4':
    '결제 정보(안전한 제3자 제공업체를 통해)',
  'legal.privacy.section3.title': '3. 데이터 처리 목적',
  'legal.privacy.section3.content':
    '귀하의 데이터는 다음 목적으로 사용됩니다:',
  'legal.privacy.section3.item1':
    'AI 서비스 제공 및 개선',
  'legal.privacy.section3.item2':
    '계정 관리 및 인증',
  'legal.privacy.section3.item3':
    '결제 및 청구 처리',
  'legal.privacy.section4.title': '4. 데이터 보안',
  'legal.privacy.section4.content':
    '당사는 조작, 손실, 파괴 또는 무단 접근으로부터 데이터를 보호하기 위한 기술적 및 조직적 보안 조치를 구현합니다. 모든 데이터 전송은 SSL/TLS를 통해 암호화됩니다.',
  'legal.privacy.section5.title': '5. 비즈니스 아이디어의 기밀성',
  'legal.privacy.section5.content':
    '제출된 비즈니스 아이디어와 틈새 쿼리는 엄격히 기밀로 처리됩니다. 제3자와 공유되지 않으며, 학습 목적으로 사용되지 않으며, 요청 시 완전히 삭제할 수 있습니다. 귀하의 아이디어는 귀하의 것입니다.',
  'legal.privacy.section6.title': '6. 귀하의 권리',
  'legal.privacy.section6.content':
    '귀하는 개인 데이터에 대해 다음과 같은 권리를 가집니다:',
  'legal.privacy.section6.item1': '저장된 데이터에 대한 접근 권리',
  'legal.privacy.section6.item2': '부정확한 데이터 정정 권리',
  'legal.privacy.section6.item3': '데이터 삭제 권리',
  'legal.privacy.section6.item4': '데이터 이동성 권리',
  'legal.privacy.section7.title': '7. 쿠키',
  'legal.privacy.section7.content':
    '당사 웹사이트는 인증 및 세션 관리를 위해 기술적으로 필요한 쿠키만 사용합니다. 귀하의 명시적 동의 없이 추적 쿠키나 제3자 분석 도구를 사용하지 않습니다.',
  'legal.privacy.section8.title': '8. 개인정보처리방침 변경',
  'legal.privacy.section8.content':
    '당사는 변경된 법적 요구 사항이나 서비스 변경 사항을 준수하기 위해 본 개인정보처리방침을 수정할 권리를 보유합니다. 현재 버전은 항상 이 페이지에서 확인할 수 있습니다.',
  'legal.privacy.contact.title': '개인정보 보호에 대해 질문이 있으신가요?',
  'legal.privacy.contact.content':
    '개인 데이터 처리에 대해 질문이 있으시면 다음 주소로 문의해주세요:',

  'auth.passwordStrength.label': '비밀번호 강도',
  'auth.passwordStrength.weak': '약함',
  'auth.passwordStrength.medium': '보통',
  'auth.passwordStrength.strong': '강함',
  'auth.passwordStrength.veryStrong': '매우 강함',
  'auth.passwordStrength.minLength': '최소 8자',
  'auth.passwordStrength.uppercase': '대문자',
  'auth.passwordStrength.number': '숫자',
  'auth.passwordStrength.special': '특수 문자',

  trial: {
    subtitle: '무료 체험',
    upgrade: '지금 업그레이드',
    creditsRemaining: '크레딧 남음',
    inputHint: '체험 버전 - 대화 기록을 사용할 수 없습니다',
    banner: {
      title: '7일 체험 활성화',
      remaining: '{{days}}일 남음',
      credits: '크레딧 사용 가능',
      upgradeNow: '지금 업그레이드',
    },
    welcome: {
      title: '무료 체험에 오신 것을 환영합니다!',
      desc: '100크레딧으로 7일 동안 AI 어시스턴트를 무료로 테스트하세요. 질문하고 가능성을 발견하세요!',
    },
    info: {
      title: '체험 제한 사항',
      credits: '7일 동안 100크레딧',
      noHistory: '대화 기록 없음',
      noSettings: '제한된 기능',
      upgrade: '전체 기능을 위해 업그레이드',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': '설정',
  'settings.subtitle': '계정 및 기본 설정 관리',
  'settings.backToOverview': '개요로 돌아가기',
  'settings.subscriptionLink': '구독 및 결제',
  'settings.saved': '변경 사항이 저장되었습니다',
  'settings.changesSaved': '변경 사항 저장됨',
  'settings.saveChanges': '변경 사항 저장',
  'settings.dataExported': '데이터가 성공적으로 내보내졌습니다',

  // Tabs
  'settings.tabs.profile': '프로필',
  'settings.tabs.preferences': '기본 설정',
  'settings.tabs.notifications': '알림',
  'settings.tabs.account': '계정 및 플랜',

  // Profile
  'settings.profile.changePhoto': '사진 변경',
  'settings.profile.photoHint': 'JPG, PNG 또는 GIF (최대 2MB)',
  'settings.profile.uploading': '업로드 중...',
  'settings.profile.photoUpdated': '프로필 사진이 업데이트되었습니다!',
  'settings.profile.name': '이름',
  'settings.profile.email': '이메일',
  'settings.profile.phone': '전화번호',
  'settings.profile.changePassword': '비밀번호 변경',
  'settings.profile.currentPassword': '현재 비밀번호',
  'settings.profile.newPassword': '새 비밀번호',
  'settings.profile.confirmPassword': '비밀번호 확인',

  // Preferences
  'settings.preferences.language': '언어',
  'settings.preferences.chooseLanguage': '언어 선택',
  'settings.preferences.timezone': '시간대',
  'settings.preferences.currency': '통화',

  // Notifications
  'settings.notifications.emailTitle': '이메일 알림',
  'settings.notifications.email.analysis': '분석 완료',
  'settings.notifications.email.analysisDesc': '분석이 준비되면 이메일 수신',
  'settings.notifications.email.credits': '크레딧 업데이트',
  'settings.notifications.email.creditsDesc': '크레딧 및 초기화에 관한 알림',
  'settings.notifications.email.billing': '청구서 및 결제',
  'settings.notifications.email.billingDesc': '청구서 및 플랜 변경에 관한 알림',
  'settings.notifications.email.newsletter': '뉴스레터',
  'settings.notifications.email.newsletterDesc': '팁, 업데이트 및 새로운 기능',
  'settings.notifications.pushTitle': '푸시 알림',
  'settings.notifications.push.analysis': '분석 완료',
  'settings.notifications.push.analysisDesc': '분석 완료 시 브라우저 알림',
  'settings.notifications.push.credits': '크레딧 경고',
  'settings.notifications.push.creditsDesc': '크레딧 잔량이 적을 때 경고',

  // Account
  'settings.account.currentSubscription': '현재 구독',
  'settings.account.plan': '플랜',
  'settings.account.price': '가격',
  'settings.account.nextBilling': '다음 청구일',
  'settings.account.manageSubscription': '구독 및 결제 관리',
  'settings.account.dataPrivacy': '데이터 및 개인정보',
  'settings.account.exportData': '데이터 내보내기',
  'settings.account.deleteAccount': '계정 삭제',

  // Delete Modal
  'settings.deleteModal.title': '계정을 삭제하시겠습니까?',
  'settings.deleteModal.subtitle': '모든 데이터가 영구적으로 삭제됩니다.',
  'settings.deleteModal.warning1': '모든 분석 및 데이터가 삭제됩니다',
  'settings.deleteModal.warning2': '활성 구독이 즉시 취소됩니다',
  'settings.deleteModal.warning3': '환불이 불가능합니다',
  'settings.deleteModal.confirmLabel': '확인을 위해 "{{word}}"을 입력하세요 *',
  'settings.deleteModal.cancel': '취소',
  'settings.deleteModal.confirm': '계정 삭제',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': '개요로 돌아가기',
  'sub.settings': '설정',
  'sub.title': '구독 및 결제',
  'sub.subtitle': '구독, 결제 방법 및 청구서 관리',
  'sub.tab.overview': '개요',
  'sub.tab.payment': '결제 방법',
  'sub.tab.billing': '청구 주소',
  'sub.tab.history': '결제 내역',
  'sub.memberSince': '회원 가입일',
  'sub.perMonth': '/월',
  'sub.baseCHF': '(CHF {{amount}} 기본)',
  'sub.nextBilling': '다음 청구일',
  'sub.creditsUsed': '사용한 크레딧',
  'sub.paymentMethod': '결제 방법',
  'sub.creditUsage': '크레딧 사용량',
  'sub.changePlan': '플랜 변경',
  'sub.reactivate': '재활성화',
  'sub.cancelSub': '구독 취소',
  'sub.manageCards': '카드 관리',
  'sub.downloadInvoices': '청구서 다운로드',
  'sub.invoicesAvailable': '{{count}}개의 PDF 청구서 사용 가능',
  'sub.accountSettings': '계정 설정',
  'sub.profileNotifications': '프로필, 알림 등',
  // Prices in EUR info
  'sub.eurInfo': '표시된 가격',
  'sub.eurLabel': '유로',
  'sub.eurRate': '환율:',
  'sub.currentRate': '현재 환율',
  // Payment Methods
  'sub.savedCards': '저장된 카드',
  'sub.newCard': '새 카드',
  'sub.default': '기본',
  'sub.setDefault': '기본값으로 설정',
  'sub.validUntil': '만료일',
  'sub.noCards': '저장된 카드가 없습니다',
  'sub.addFirstCard': '첫 번째 카드 추가',
  'sub.securePayments': '안전한 결제',
  'sub.securePaymentsDesc': '모든 결제 데이터는 암호화되어 결제 제공업체에 안전하게 저장됩니다. 당사는 완전한 카드 번호를 저장하지 않습니다.',
  // Billing Address
  'sub.billingAddress': '청구 주소',
  'sub.edit': '편집',
  'sub.name': '이름',
  'sub.streetAddress': '도로명 및 번호',
  'sub.zip': '우편번호',
  'sub.city': '도시',
  'sub.country': '국가',
  'sub.address': '주소',
  'sub.save': '저장',
  'sub.cancel': '취소',
  'sub.country.switzerland': '스위스',
  'sub.country.germany': '독일',
  'sub.country.austria': '오스트리아',
  'sub.country.netherlands': '네덜란드',
  'sub.country.belgium': '벨기에',
  // Payment History
  'sub.paymentHistory': '결제 내역',
  'sub.allInvoicesPDF': '로고가 포함된 모든 청구서를 PDF로 다운로드',
  'sub.downloadAll': '모두 다운로드',
  'sub.eurInvoiceNote': '청구서는 항상 CHF로 발행됩니다. 표시된 EUR 금액은 참조용입니다.',
  'sub.date': '날짜',
  'sub.description': '설명',
  'sub.net': '순액',
  'sub.vat': '부가가치세',
  'sub.total': '합계',
  'sub.status': '상태',
  'sub.pdf': 'PDF',
  'sub.invoices': '청구서',
  'sub.totalAmount': '총액',
  // Change Plan Modal
  'sub.changePlanTitle': '플랜 변경',
  'sub.current': '현재',
  'sub.month': '/월',
  'sub.showLess': '간략히 보기',
  'sub.showMore': '+{{count}}개 더 보기',
  'sub.switchPlan': '플랜 변경',
  'sub.eurPriceNote': 'EUR로 표시된 가격 ({{note}}). 결제는 CHF로 이루어집니다.',
  // Cancel Modal
  'sub.cancelTitle': '구독을 취소하시겠습니까?',
  'sub.cancelIrreversible': '이 작업은 취소할 수 없습니다.',
  'sub.cancelWarning1': '모든 남은 크레딧이 만료됩니다',
  'sub.cancelWarning2': '무료 플랜으로 다운그레이드',
  'sub.cancelWarning3': '모든 프리미엄 기능 손실',
  'sub.pauseInstead': '대안: 구독 일시 중지?',
  'sub.pauseDesc': '구독을 일시 중지하고 데이터를 유지하세요.',
  'sub.preferPause': '일시 중지 선호',
  'sub.cancelReason': '취소 사유',
  'sub.selectReason': '선택하세요...',
  'sub.reason.tooExpensive': '너무 비쌈',
  'sub.reason.notUsing': '충분히 사용하지 않음',
  'sub.reason.missingFeatures': '필요한 기능이 없음',
  'sub.reason.foundAlternative': '대안을 찾음',
  'sub.reason.other': '기타',
  'sub.confirmType': '확인: "CANCEL" 입력 *',
  'sub.cancelNow': '지금 취소',
  // Add Card Modal
  'sub.addCardTitle': '새 카드 추가',
  'sub.cardHolder': '카드 소지자 *',
  'sub.cardNumber': '카드 번호 *',
  'sub.expiryDate': '만료일 *',
  'sub.addCard': '카드 추가',
  // Change Card Modal
  'sub.choosePayment': '결제 방법 선택',
  'sub.active': '활성',
  'sub.close': '닫기',
  // Toast messages
  'sub.toast.cancelled': '구독이 청구 기간 말에 취소되었습니다.',
  'sub.toast.reactivated': '구독이 성공적으로 재활성화되었습니다!',
  'sub.toast.planChanged': '플랜이 {{plan}}(으)로 성공적으로 변경되었습니다!',
  'sub.toast.defaultChanged': '기본 결제 방법이 변경되었습니다.',
  'sub.toast.cannotDeleteDefault': '기본 카드는 삭제할 수 없습니다.',
  'sub.toast.cardRemoved': '카드가 제거되었습니다.',
  'sub.toast.fillAll': '모든 필드를 입력해주세요.',
  'sub.toast.cardAdded': '새 카드가 성공적으로 추가되었습니다!',
  'sub.toast.billingSaved': '청구 주소가 저장되었습니다.',
  'sub.toast.invoiceDownloaded': '청구서 {{id}}이(가) 다운로드되었습니다!',
  'sub.toast.pdfError': 'PDF 생성 중 오류가 발생했습니다.',
  // Chat interface
  'sub.notEnoughCredits': '크레딧이 부족합니다',
  'sub.needCredits': '질문당 최소 {{count}}크레딧이 필요합니다.',
  'sub.creditsLow': '크레딧 부족',
  'sub.questionsLeft': '{{count}}개 질문 가능.',
  'sub.plan': '플랜',
  'sub.base': '기본',
  'sub.unlimited': '무제한',
  'sub.status.active': '활성',
  'sub.status.cancelled': '취소됨',
  'sub.status.paused': '일시 중지됨',
  'sub.invoice': '청구서',
  'sub.from': '발신자',
  'sub.to': '수신자',
  'sub.vatId': '부가가치세 ID',
  'sub.tel': '전화',
  'sub.invoiceDate': '청구일자',
  'sub.invoiceNumber': '청구서 번호',
  'sub.paymentStatus': '결제 상태',
  'sub.creditCard': '신용카드',
  'sub.quantity': '수량',
  'sub.price': '단가',
  'sub.amount': '금액',
  'sub.subtotal': '소계',
  'sub.bank': '은행',
  'sub.card': '카드',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': '홍길동',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': '관리자 대시보드',
  'admin.subtitle': '제어 센터',
  'admin.superAdmin': '슈퍼 관리자',
  'admin.logout': '로그아웃',
  'admin.tabs.users': '사용자 관리',
  'admin.tabs.downgrades': '다운그레이드',
  'admin.tabs.tips': '오늘의 팁',
  'admin.tabs.coupons': '쿠폰 코드',
  'admin.tabs.website': '웹사이트 편집기',
  'admin.tabs.ai': 'AI 설정',
  'admin.tabs.transactions': '거래 로그',
  'admin.tabs.stats': '통계',
  'admin.users.searchPlaceholder': '사용자 검색 (이메일 또는 이름)...',
  'admin.users.manageSubscription': '구독 관리',
  'admin.users.grantFree': '무료 계정 부여',
  'admin.users.blockUser': '사용자 차단',
  'admin.users.cancellationPlaceholder': '구독이 취소되는 이유는 무엇인가요?',
  'admin.users.selectPlan': '플랜 선택',
  'admin.users.subChanged': '{{name}}님의 구독이 {{plan}}(으)로 변경되었습니다',
  'admin.users.noReasonGiven': '이유가 제공되지 않음',
  'admin.users.subCancelled': '{{name}}님의 구독이 취소되었습니다 ({{date}}까지 유효)',
  'admin.users.paused': '일시 중지됨',
  'admin.users.subPaused': '{{name}}님의 구독이 일시 중지되었습니다',
  'admin.users.subReactivated': '{{name}}님의 구독이 재활성화되었습니다',
  'admin.users.freeAccount': '무료 계정',
  'admin.users.blocked': '차단됨',
  'admin.users.cancelledExpiring': '취소됨 (만료 예정)',
  'admin.users.cancelledOn': '취소일:',
  'admin.users.endsOn': '종료일:',
  'admin.users.daysRemaining': '일 남음',
  'admin.users.expired': '(만료됨)',
  'admin.users.total': '총합:',
  'admin.users.usersLabel': '명의 사용자',
  'admin.users.free': '무료',
  'admin.users.block': '차단',
  'admin.users.unblock': '차단 해제',
  'admin.users.unblockUser': '사용자 차단 해제',
  'admin.users.selectAction': '작업 선택',
  'admin.users.cancelSub': '구독 취소',
  'admin.users.cancelSubDesc': '월말에 취소',
  'admin.users.pauseSub': '구독 일시 중지',
  'admin.users.pauseSubDesc': '임시 일시 중지',
  'admin.users.changePlan': '플랜 변경',
  'admin.users.changePlanDesc': '다른 플랜으로 전환',
  'admin.users.reactivateSub': '구독 재활성화',
  'admin.users.reactivateDesc': '취소 실행 취소',
  'admin.users.alreadyCancelled': '이미 취소된 구독입니다',
  'admin.users.planLabel': '플랜',
  'admin.users.cancellationReasonOpt': '취소 사유 (선택 사항)',
  'admin.users.cancelInfo1': '구독이 다음 날짜에 종료됩니다',
  'admin.users.cancelInfo2': '(월말). 그때까지 사용자는 모든 기능에 액세스할 수 있습니다. 환불 없음.',
  'admin.users.newPlan': '새 플랜',
  'admin.users.warning': '경고',
  'admin.users.blockDesc': '사용자는 즉시 로그아웃되며 다시 로그인할 수 없습니다. 모든 활성 세션이 종료됩니다.',
  'admin.users.confirmUnblock': '차단 해제 확인',
  'admin.users.unblockDesc': '사용자가 다시 로그인하여 모든 기능을 사용할 수 있습니다.',
  'admin.users.afterBlock': '차단 후:',
  'admin.users.afterUnblock': '차단 해제 후:',
  'admin.users.noAccountAccess': '계정 접근 불가',
  'admin.users.noNewAnalyses': '새 분석 불가능',
  'admin.users.creditsStored': '크레딧 및 기록은 저장됨',
  'admin.users.accessRestored': '계정 접근 복원됨',
  'admin.users.allFeaturesAvail': '모든 기능 다시 사용 가능',
  'admin.users.creditsPreserved': '크레딧 및 기록 보존됨',
  'admin.users.downgrade': '플랜 다운그레이드',
  'admin.users.grantFreeBtn': '무료 부여',
  'admin.users.durationMonths': '기간 (개월)',
  'admin.users.months': '개월',
  'admin.users.freePlan': '무료',
  'admin.users.freeSummary': '받음',
  'admin.users.withCredits': '크레딧 포함',
  'admin.users.credits': '크레딧',
  'admin.users.subInfo': '구독 정보',
  'admin.users.currentPlan': '현재 플랜',
  'admin.users.joined': '가입일',
  'admin.users.totalSpent': '총 지출',
  'admin.users.paymentMethod': '결제 방법',
  'admin.users.validThrough': '만료일',
  'admin.users.billingAddress': '청구 주소',
  'admin.users.transactionHistory': '거래 내역',
  'admin.users.cancellationDate': '취소일',
  'admin.users.validUntil': '만료일 (월말)',
  'admin.users.cancellationReason': '취소 사유',
  'admin.users.noReason': '이유 없음',
  'admin.users.timeRemaining': '남은 시간',
  'admin.users.daysUntilDeactivation': '비활성화까지 남은 일수',
  'admin.table.user': '사용자',
  'admin.table.plan': '플랜',
  'admin.table.subStatus': '구독 상태',
  'admin.table.cancellation': '취소',
  'admin.table.payment': '결제 방법',
  'admin.table.spending': '지출',
  'admin.table.actions': '작업',
  'admin.actions.viewDetails': '세부 정보 보기',
  'admin.actions.manageSubscription': '구독 관리',
  'admin.actions.grantFree': '무료 액세스 부여',
  'admin.actions.block': '사용자 차단',
  'admin.actions.unblock': '사용자 차단 해제',
  'admin.actions.cancel': '취소',
  'admin.actions.save': '저장',
  'admin.actions.delete': '삭제',
  'admin.actions.confirm': '확인',
  'admin.actions.done': '완료',
  'admin.actions.edit': '편집',
  'admin.actions.close': '닫기',
  'admin.table.status': '상태',
  'admin.filter.all': '모두',
  'admin.subscription.active': '활성',
  'admin.subscription.cancelled': '취소됨',
  'admin.subscription.paused': '일시 중지됨',
  'admin.subscription.unknown': '알 수 없음',
  'admin.status.active': '활성',
  'admin.status.inactive': '비활성',
  'admin.status.pending': '보류 중',
  'admin.status.approved': '승인됨',
  'admin.status.rejected': '거부됨',
  'admin.coupons.title': '쿠폰 관리',
  'admin.coupons.subtitle': '쿠폰 코드 생성 및 관리',
  'admin.coupons.newCoupon': '새 쿠폰',
  'admin.coupons.registrationCoupons': '등록 쿠폰',
  'admin.coupons.trialCoupons': '체험 액세스 쿠폰',
  'admin.coupons.type': '유형',
  'admin.coupons.plan': '플랜',
  'admin.coupons.value': '값',
  'admin.coupons.usage': '사용량',
  'admin.coupons.validUntil': '만료일',
  'admin.coupons.created': '생성일',
  'admin.coupons.actions': '작업',
  'admin.coupons.copyCode': '코드 복사',
  'admin.coupons.allPlans': '모든 플랜',
  'admin.coupons.discount': '할인',
  'admin.coupons.days': '일',
  'admin.coupons.months': '개월',
  'admin.coupons.free': '무료',
  'admin.coupons.unlimited': '무제한',
  'admin.coupons.createRegistration': '등록 쿠폰 생성',
  'admin.coupons.createTrial': '체험 액세스 쿠폰 생성',
  'admin.coupons.couponCode': '쿠폰 코드',
  'admin.coupons.codePlaceholder': '예: NF-7X3K9M',
  'admin.coupons.generateCode': '새 코드 생성',
  'admin.coupons.alertFillRequired': '모든 필수 필드를 입력해주세요',
  'admin.coupons.alertSelectExpiry': '만료일을 선택하거나 "무제한 유효기간"을 활성화해주세요',
  'admin.coupons.alertCreateError': '쿠폰 생성 오류',
  'admin.coupons.confirmDelete': '이 쿠폰을 삭제하시겠습니까?',
  'admin.coupons.discountPercent': '할인율 (%)',
  'admin.coupons.bonusCredits': '보너스 크레딧',
  'admin.coupons.freeDuration': '무료 기간',
  'admin.coupons.maxUses': '최대 사용 횟수',
  'admin.coupons.expiryDate': '만료일',
  'admin.coupons.unlimitedValidity': '무제한 유효기간',
  'admin.coupons.unlimitedUses': '무제한 사용',
  'admin.coupons.trialCredits': '체험 크레딧',
  'admin.coupons.trialDuration': '체험 기간',
  'admin.coupons.typePlaceholder': '예: 얼리버드, 파트너, 인플루언서',
  'admin.coupons.duration': '기간',
  'admin.stats.totalUsers': '총 사용자',
  'admin.stats.monthlyRevenue': '월간 수익',
  'admin.stats.activeSubscriptions': '활성 구독',
  'admin.stats.average': '평균',
  'admin.stats.revenuePerUser': '사용자당 수익',
  'admin.stats.grossRevenue': '총 수익',
  'admin.stats.net': '순수익',
  'admin.stats.netRevenue': '순수익',
  'admin.stats.churnRate': '이탈률',
  'admin.stats.planDistribution': '플랜 분포',
  'admin.stats.users': '사용자',
  'admin.stats.revenueByPlan': '플랜별 수익',
  'admin.stats.recentActivity': '최근 활동',
  'admin.stats.activity1': 'Thomas Weber님이 빌더로 업그레이드함',
  'admin.stats.activity2': '새 사용자 등록함',
  'admin.stats.activity3': 'Anna Schmidt님이 프로로 업그레이드함',
  'admin.stats.hoursAgo2': '2시간 전',
  'admin.stats.hoursAgo5': '5시간 전',
  'admin.stats.dayAgo1': '1일 전',
  'admin.stats.couponStats': '쿠폰 통계',
  'admin.stats.totalRedemptions': '총 사용 횟수',
  'admin.stats.activeCoupons': '활성 쿠폰',
  'admin.stats.registrationRedemptions': '등록 쿠폰 사용',
  'admin.stats.trialRedemptions': '체험 쿠폰 사용',
  'admin.stats.couponDistribution': '쿠폰 분포',
  'admin.stats.registrationCoupons': '등록 쿠폰',
  'admin.stats.trialCoupons': '체험 쿠폰',
  'admin.stats.expiredInactive': '만료/비활성',
  'admin.stats.topCoupons': '가장 많이 사용된 쿠폰',
  'admin.stats.redemptions': '사용 횟수',
  'admin.stats.noCouponsRedeemed': '아직 사용된 쿠폰이 없습니다',
  'admin.downgrade.pending': '보류 중',
  'admin.downgrade.refunds': '환불',
  'admin.downgrade.sectionRequests': '요청',
  'admin.downgrade.sectionStats': '통계',
  'admin.downgrade.sectionRules': '규칙',
  'admin.downgrade.pendingRequests': '보류 중인 요청',
  'admin.downgrade.approvedRequests': '승인된 요청',
  'admin.downgrade.rejectedRequests': '거부된 요청',
  'admin.downgrade.activeRules': '활성 규칙',
  'admin.downgrade.autoRules': '자동 다운그레이드 규칙',
  'admin.downgrade.autoRulesDesc': '사용 행동에 따라 자동으로 다운그레이드를 트리거하는 규칙 생성',
  'admin.downgrade.newRule': '새 규칙',
  'admin.downgrade.totalRules': '총 규칙',
  'admin.downgrade.triggeredActions': '트리거된 작업',
  'admin.downgrade.conditionsAnd': '조건 (AND로 연결)',
  'admin.downgrade.action': '작업',
  'admin.downgrade.successTitle': '다운그레이드 성공!',
  'admin.downgrade.successDesc': '사용자가 성공적으로 다운그레이드되었고 환불이 처리되었습니다.',
  'admin.downgrade.closing': '닫는 중...',
  'admin.downgrade.title': '사용자 다운그레이드',
  'admin.downgrade.currentPlan': '현재 플랜',
  'admin.downgrade.spending': '지출',
  'admin.downgrade.availablePlans': '다운그레이드 가능한 플랜',
  'admin.downgrade.perMonth': '/월',
  'admin.downgrade.refundCalc': '환불 계산',
  'admin.downgrade.currentPlanLabel': '현재 플랜',
  'admin.downgrade.newPlan': '새 플랜',
  'admin.downgrade.remainingDays': '남은 일수',
  'admin.downgrade.daysOf': '30일 중 15일',
  'admin.downgrade.proRataRefund': '비례 환불',
  'admin.downgrade.importantNote': '중요 참고사항',
  'admin.downgrade.warningDesc': '다운그레이드가 즉시 실행됩니다. 사용자는 프리미엄 기능에 대한 액세스를 잃고 초과 크레딧이 제거됩니다.',
  'admin.downgrade.processing': '처리 중...',
  'admin.downgrade.execute': '다운그레이드 실행',
  'admin.downgrade.notification': '알림',
  'admin.downgrade.noNotification': '알림 없음',
  'admin.downgrade.daysPeriod': '일 유예 기간',
  'admin.downgrade.created': '생성일:',
  'admin.downgrade.triggered': '트리거됨',
  'admin.downgrade.noRules': '아직 생성된 규칙이 없습니다',
  'admin.downgrade.createFirstRule': '첫 번째 규칙 만들기',
  'admin.downgrade.editRule': '규칙 편집',
  'admin.downgrade.createRule': '새 규칙 생성',
  'admin.downgrade.ruleName': '규칙 이름',
  'admin.downgrade.description': '설명',
  'admin.downgrade.allConditions': '조건 (모두 충족해야 함)',
  'admin.downgrade.addCondition': '조건 추가',
  'admin.downgrade.type': '유형',
  'admin.downgrade.value': '값',
  'admin.downgrade.fromPlan': '현재 플랜',
  'admin.downgrade.toPlan': '대상 플랜',
  'admin.condition.inactivity': '비활성',
  'admin.condition.creditUsage': '크레딧 사용량',
  'admin.condition.loginFrequency': '로그인 빈도',
  'admin.condition.featureUsage': '기능 사용량',
  'admin.condition.supportTickets': '지원 티켓',
  'admin.operator.lessThan': '미만',
  'admin.operator.greaterThan': '초과',
  'admin.operator.equals': '정확히',
  'admin.operator.between': '사이',
  'admin.unit.days': '일',
  'admin.unit.perMonth': '/월',
  'admin.unit.count': '개수',
  'admin.transactions.all': '모든 거래',
  'admin.transactions.allCards': '모든 카드',
  'admin.transactions.notFound': '거래를 찾을 수 없습니다',
  'admin.transactions.totalLabel': '합계',
  'admin.transactions.transactions': '거래',
  'admin.tips.title': '오늘의 팁',
  'admin.tips.subtitle': '모든 사용자에게 표시될 팁 생성 및 관리',
  'admin.tips.active': '활성',
  'admin.tips.currentlyShown': '이 팁이 현재 모든 사용자에게 표시되고 있습니다',
  'admin.tips.createNew': '새 팁 생성',
  'admin.tips.generating': '생성 중...',
  'admin.tips.generateAI': 'AI 팁 생성',
  'admin.tips.titleLabel': '제목',
  'admin.tips.titlePlaceholder': '예: 오늘의 팁',
  'admin.tips.category': '카테고리',
  'admin.tips.categoryTip': '팁',
  'admin.tips.categoryFeature': '새 기능',
  'admin.tips.categoryProductivity': '생산성',
  'admin.tips.categoryUpdate': '업데이트',
  'admin.tips.content': '내용',
  'admin.tips.contentPlaceholder': '사용자를 위한 팁을 작성하세요...',
  'admin.tips.addTip': '팁 추가',
  'admin.tips.allTips': '모든 팁',
  'admin.tips.noTips': '아직 생성된 팁이 없습니다',
  'admin.tips.noTipsHint': '"AI 팁 생성"을 클릭하여 시작하세요',
  'admin.noData': '사용 가능한 데이터가 없습니다',
  'admin.range.7d': '7일',
  'admin.range.30d': '30일',
  'admin.range.90d': '90일',
  'admin.range.1y': '1년',
  'admin.actions.saveSettings': '설정 저장',
  'admin.actions.create': '생성',
  'admin.downgrade.sectionReports': '보고서',
  'admin.downgrade.settings': '다운그레이드 설정',
  'admin.downgrade.autoApprove': '자동 승인',
  'admin.downgrade.autoApproveDesc': '다운그레이드 요청 자동 승인',
  'admin.downgrade.refundPolicy': '환불 정책',
  'admin.downgrade.prorata': '비례 환불',
  'admin.downgrade.prorataDesc': '남은 일수에 따른 비례 환불',
  'admin.downgrade.fullRefund': '전액 환불',
  'admin.downgrade.fullRefundDesc': '가격 차이의 완전한 환불',
  'admin.downgrade.noRefund': '환불 없음',
  'admin.downgrade.noRefundDesc': '환불 없는 다운그레이드',
  'admin.downgrade.daysRemaining15': '(15일 남음 기준)',
  'admin.downgrade.requestsTitle': '다운그레이드 요청',
  'admin.downgrade.approvalRate': '승인율',
  'admin.downgrade.mostCommonTransition': '가장 흔한 전환',
  'admin.downgrade.mostCommonReason': '가장 흔한 사유',
  'admin.downgrade.avgProcessingTime': '평균 처리 시간',
  'admin.downgrade.avgTimeDesc': '결정까지 평균 시간',
  'admin.downgrade.totalRefunds': '총 환불액',
  'admin.downgrade.pendingRefunds': '보류 중인 환불',
  'admin.downgrade.summary': '요약',
  'admin.downgrade.total': '합계',
  'admin.downgrade.csvDesc': 'Excel, Google Sheets용',
  'admin.downgrade.downloadCSV': 'CSV로 다운로드',
  'admin.downgrade.jsonDesc': '개발자, API용',
  'admin.downgrade.downloadJSON': 'JSON으로 다운로드',
  'admin.downgrade.exportInfo': '내보내기에는 다음이 포함됩니다',
  'admin.downgrade.entries': '선택한 기간의 항목',
  'admin.downgrade.topReasons': '가장 흔한 다운그레이드 사유',
  'admin.downgrade.refundHistory': '환불 내역',
  'admin.downgrade.noRefunds': '아직 환불 내역이 없습니다',
  'admin.downgrade.statistics': '다운그레이드 통계',
  'admin.downgrade.requests': '요청',
  'admin.downgrade.monthlyTrend': '월간 추이',
  'admin.downgrade.planTransitions': '플랜 전환',
  'admin.downgrade.trend': '추이 (전월 대비)',
  'admin.downgrade.trendDesc': '다운그레이드 감소 = 좋음',
  'admin.coupons.allPlansUniversal': '모든 플랜 (유니버설)',
  'admin.coupons.onlyStarter': '스타터 전용',
  'admin.coupons.onlyPro': '프로 전용',
  'admin.coupons.onlyBuilder': '빌더 전용',
  'admin.coupons.allPlansHint': '유니버설 쿠폰을 위해 "모든 플랜" 선택',
  'admin.coupons.discountOptional': '할인율 % (선택 사항)',
  'admin.coupons.discountPlaceholder': '예: 50 (50% 할인)',
  'admin.coupons.bonusCreditsOptional': '보너스 크레딧 (선택 사항)',
  'admin.coupons.bonusCreditsPlaceholder': '예: 500',
  'admin.coupons.freeDurationOptional': '무료 기간 (선택 사항)',
  'admin.coupons.durationPlaceholder': '예: 30',
  'admin.coupons.freeDurationHint': '예: 30일 무료 사용',
  'admin.coupons.noLimit': '사용 제한 없음',
  'admin.coupons.noExpiry': '만료일 없음',
  'admin.coupons.creditsPlaceholder': '예: 100',
  'admin.coupons.creditsHint': '체험 액세스를 위한 크레딧 수',
  'admin.coupons.trialDurationHint': '체험 액세스의 유효 기간',
  'admin.coupons.autoCalculated': '체험 기간에서 자동 계산됨',
  'admin.websiteEditor.title': '웹사이트 편집기',
  'admin.websiteEditor.subtitle': '홈페이지의 모든 섹션 편집',
  'admin.websiteEditor.openPreview': '미리보기 열기',
  'admin.websiteEditor.group.structure': '페이지 구조',
  'admin.websiteEditor.group.design': '디자인 및 레이아웃',
  'admin.websiteEditor.group.settings': '설정',
  'admin.websiteEditor.tab.navbar': '내비게이션',
  'admin.websiteEditor.tab.howitworks': '작동 방식',
  'admin.websiteEditor.tab.about': '회사 소개',
  'admin.websiteEditor.tab.pricing': '가격',
  'admin.websiteEditor.tab.sections': '섹션',
  'admin.websiteEditor.tab.media': '미디어',
  'admin.websiteEditor.tab.chatwidget': '문의하기',
  'admin.websiteEditor.tab.invoice': '청구서',
  'admin.websiteEditor.tab.legal': '법적 고지',
  'admin.websiteEditor.tab.seo': '기본 SEO',
  'admin.websiteEditor.tab.advancedseo': '고급 SEO',
  'admin.websiteEditor.tab.versions': '버전',
  'admin.hero.title': '히어로 섹션 편집',
  'admin.hero.subtitle': '홈페이지의 텍스트, 버튼 및 통계',
  'admin.hero.reset': '초기화',
  'admin.hero.save': '저장',
  'admin.hero.savedMsg': '히어로 데이터가 저장되었습니다!',
  'admin.hero.badge': '뱃지 텍스트',
  'admin.hero.headings': '제목',
  'admin.hero.line1White': '라인 1 (흰색)',
  'admin.hero.line2Gold': '라인 2 (금색)',
  'admin.hero.subtitleSection': '부제목',
  'admin.hero.line1': '라인 1',
  'admin.hero.line2': '라인 2',
  'admin.hero.buttons': '버튼',
  'admin.hero.primaryBtn': '기본 버튼 (금색)',
  'admin.hero.secondaryBtn': '보조 버튼 (테두리)',
  'admin.hero.stats': '통계',
  'admin.hero.statN': '통계 {{n}}',
  'admin.hero.value': '값',
  'admin.hero.label': '레이블',
  'admin.hero.previewNote': '변경 사항은 저장 후 홈페이지에 표시됩니다. 미리보기를 보려면 페이지를 새로고침하세요.',

  // Idea History
  'history.title': '아이디어 기록',
  'history.countLabel': '{{count}}개 분석',
  'history.recentLabel': '최근 분석',
  'history.exportAll': '모두 내보내기',
  'history.metrics.marketSize': '시장 규모',
  'history.metrics.competition': '경쟁',
  'history.metrics.startingCapital': '초기 자본',
  'history.metrics.timeToMarket': '출시 기간',
  'history.metrics.profitPotential': '수익 잠재력',
  'history.metrics.scalability': '확장성',
  'history.summary.title': '요약',
  'history.download': '다운로드',
  'history.downloadJSON': 'JSON으로 저장',
  'history.downloadTXT': 'TXT로 저장',
  'history.downloadPDF': 'PDF로 저장',
  'history.fullAnalysis': '전체 분석',
  'history.searchPlaceholder': '제목 또는 태그로 검색...',
  'history.filterAll': '모든 평가',
  'history.loading': '분석 로딩 중...',
  'history.noResults': '검색 결과가 없습니다',
  'history.empty': '아직 분석이 없습니다',
  'history.emptyHint': 'AI 어시스턴트에서 분석을 시작하세요',
  'history.delete': '삭제',
  'history.cancel': '취소',
  'history.deleteModalTitle': '분석을 삭제하시겠습니까?',
  'history.deleteModalDesc': '"{{title}}"이(가) 영구적으로 삭제됩니다.',
  'history.errorLoading': '분석 로딩 중 오류 발생',
  'history.deleteSuccess': '분석이 성공적으로 삭제되었습니다',
  'history.deleteError': '분석 삭제 중 오류 발생',
  'history.jsonExported': 'JSON 내보내기 완료',
  'history.txtExported': 'TXT 내보내기 완료',
  'history.allExported': '{{count}}개 아이디어 내보내기 완료',
  'history.analysisHeader': '아이디어 분석',
  'history.titleLabel': '제목',
  'history.ratingLabel': '평가',
  'history.dateLabel': '날짜',
  'history.creditsLabel': '크레딧',
  'history.analysisSection': '분석',

  // Overview
  'overview.title': '개요',
  'overview.last24h': '지난 24시간',
  'overview.analysesToday': '오늘의 분석',
  'overview.totalAnalyses': '총 분석',
  'overview.successRate': '성공률',
  'overview.topRatings': '최고 평가',
  'overview.recentActivity': '최근 활동',
  'overview.viewAll': '모두 보기',
  'overview.quickAccess': '빠른 접근',
  'overview.quick.newAnalysis': '새 분석 시작',
  'overview.quick.newAnalysisDesc': 'AI 기반 새 틈새 분석 시작',
  'overview.quick.myAnalyses': '내 분석',
  'overview.quick.myAnalysesDesc': '모든 이전 분석 보기',
  'overview.quick.buyCredits': '크레딧 구매',
  'overview.quick.buyCreditsDesc': '더 많은 분석을 위한 추가 크레딧',
  'overview.quick.settings': '설정',
  'overview.quick.settingsDesc': '프로필 및 기본 설정 맞춤화',
  'overview.unlimitedCredits': '무제한 크레딧 사용 가능',
  'overview.creditsAvailable': '크레딧 사용 가능',
  'overview.upgradePlan': '플랜 업그레이드',
  'overview.buyCredits': '크레딧 구매',
  'overview.creditUsage': '이번 달 크레딧 사용량',
  'overview.available': '사용 가능',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': '업그레이드',
  'admin.transactions.downgrades': '다운그레이드',
  'admin.transactions.visa': '비자',
  'admin.transactions.mastercard': '마스터카드',
  'admin.transactions.amex': '아멕스',

  'admin.users.grantFreeSuccess': '{{name}}님에게 {{months}}개월 무료 {{plan}} 플랜이 부여되었습니다',
  'admin.users.blockSuccess': '{{name}}님이 차단되었습니다',
  'admin.users.unblockSuccess': '{{name}}님의 차단이 해제되었습니다',
  'admin.users.removeFreeSuccess': '{{name}}님의 무료 상태가 제거되었습니다',

  'admin.downgrade.plans.builder': '빌더',
  'admin.downgrade.plans.pro': '프로',
  'admin.downgrade.plans.starter': '스타터',
  'admin.downgrade.plans.free': '무료',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': '새 기능 발견',
  'admin.tips.productivityBoost': '생산성 향상',
  'admin.tips.importantUpdate': '중요 업데이트',
  'admin.tips.tipOfDay': '오늘의 팁',

  'admin.actions.activate': '활성화',
  'admin.actions.deactivate': '비활성화',
  'admin.websiteEditor.tab.features': '기능',
  'admin.websiteEditor.tab.testimonials': '사용자 후기',
  'admin.websiteEditor.tab.faq': '자주 묻는 질문',
  'admin.websiteEditor.tab.cta': '행동 촉구',
  'admin.websiteEditor.tab.footer': '푸터',
  'admin.websiteEditor.tab.design': '디자인',
  'admin.websiteEditor.tab.customcode': '사용자 정의 코드',
  'admin.websiteEditor.tab.socials': '소셜 미디어',
  'admin.websiteEditor.tab.importexport': '가져오기/내보내기',

  // --- AI Settings Editor ---
  'admin.ai.title': 'AI 어시스턴트 설정',
  'admin.ai.subtitle': '동작, 스타일 및 분석 깊이 구성',
  'admin.ai.smartWeightingActive': '스마트 가중치 활성화',
  'admin.ai.smartWeightingDesc': 'AI는 모든 관점을 스마트 가중치로 자동 결합합니다. 여러 프리셋이 있는 경우 첫 번째 프리셋의 가중치가 가장 높습니다(기본 프리셋). 가중치를 수동으로 조정할 수도 있습니다.',
  'admin.ai.modelTitle': 'IdeaVerdict AI 모델',
  'admin.ai.modelSubtitle': '모든 사용자 분석을 위한 AI 엔진 선택',
  'admin.ai.activeModel': '활성 모델:',
  'admin.ai.activeModelDesc': '모든 사용자가 이 모델로부터 응답을 받습니다.',
  'admin.ai.recommendations': '최적 결과를 위한 권장 사항',
  'admin.ai.new': '새로운',
  'admin.ai.recommendationsDesc': '최고의 분석 품질을 위해 검증된 프리셋 조합',
  'admin.ai.recommendationsInfo': '이 조합들은 테스트를 거쳐 최상의 결과를 제공합니다. 권장 사항을 클릭하여 직접 적용하세요.',
  'admin.ai.active': '활성',
  'admin.ai.apply': '적용',
  'admin.ai.avoid': '피하기',
  'admin.ai.excellentQuality': '우수한 품질',
  'admin.ai.goodQuality': '좋은 품질',
  'admin.ai.poorQuality': '희석된 품질 - 권장하지 않음',
  'admin.ai.proTips': '프로 팁',
  'admin.ai.tip1Title': '2개 프리셋이 최적:',
  'admin.ai.tip1Desc': '희석 없는 명확한 관점',
  'admin.ai.tip2Title': '기본 프리셋이 중요:',
  'admin.ai.tip2Desc': '첫 번째 프리셋이 가장 큰 영향력',
  'admin.ai.tip3Title': '반대되는 조합 피하기:',
  'admin.ai.tip3Desc': '"극단적" + "창의적" = 모순됨',
  'admin.ai.tip4Title': '최대 3개 프리셋:',
  'admin.ai.tip4Desc': '4개 이상의 프리셋은 결과가 너무 일반적이 됨',
  'admin.ai.warningManyPresets': '경고: 프리셋이 많음',
  'admin.ai.warningManyPresetsDesc': '{{count}}개의 프리셋이 선택되었습니다. 이는 결과를 희석시킬 수 있습니다.',
  'admin.ai.warningRecommend': '권장: 최대 2-3개 프리셋',
  'admin.ai.forOptimalResults': '최적의 결과를 위해',
  'admin.ai.presets': '프리셋',
  'admin.ai.multiSelect': '(복수 선택 가능)',
  'admin.ai.presetsDesc': '하나 이상의 프리셋을 선택하세요. 첫 번째 프리셋은 가장 높은 가중치를 가진 기본 프리셋입니다.',
  'admin.ai.primaryPreset': '기본 프리셋',
  'admin.ai.weightControl': '가중치 제어',
  'admin.ai.weightControlDesc': '각 프리셋이 분석에 얼마나 강하게 영향을 미치는지 조정',
  'admin.ai.manual': '수동',
  'admin.ai.automatic': '자동',
  'admin.ai.autoWeightingActive': '자동 가중치 활성화:',
  'admin.ai.autoWeightingDesc': '프리셋 수에 따라 가중치가 자동으로 최적화됩니다.',
  'admin.ai.primary': '기본',
  'admin.ai.totalWeight': '합계',
  'admin.ai.shouldBe100': '100%가 되어야 함',
  'admin.ai.normalize': '정규화',
  'admin.ai.combinedSettings': '결합 설정',
  'admin.ai.presetsCount': '개 프리셋',
  'admin.ai.strictness': '엄격함',
  'admin.ai.realism': '현실성',
  'admin.ai.creativity': '창의성',
  'admin.ai.detailLevel': '세부 수준',
  'admin.ai.customInstructions': '사용자 정의 지침',
  'admin.ai.customInstructionsDesc': '프리셋과 결합되는 추가 지침',
  'admin.ai.customInstructionsPlaceholder': '예: "DACH 시장에 집중", "항상 구체적인 숫자 사용", "기존 경쟁사와 비교", "항상 예시와 함께 답변"...',
  'admin.ai.customInstructionsHint': '이 지침은 선택한 프리셋과 자동으로 결합됩니다.',
  'admin.ai.manualFinetuning': '수동 미세 조정',
  'admin.ai.manualFinetuningHint': '(선택 사항, 프리셋 값 재정의)',
  'admin.ai.manualFinetuningDesc': '미세 조정이 필요한 경우 결합된 값을 수동으로 조정하세요.',
  'admin.ai.tone': '어조',
  'admin.ai.mild': '온화한',
  'admin.ai.strict': '엄격한',
  'admin.ai.creative': '창의적인',
  'admin.ai.realistic': '현실적인',
  'admin.ai.conservative': '보수적인',
  'admin.ai.compact': '간결한',
  'admin.ai.detailed': '상세한',
  'admin.ai.responseLength': '응답 길이',
  'admin.ai.short': '짧고 간결하게',
  'admin.ai.medium': '중간',
  'admin.ai.long': '상세하게',
  'admin.ai.focusAreas': '분석 초점 영역',
  'admin.ai.autoRating': '자동 평가',
  'admin.ai.autoRatingDesc': '모든 분석은 자동으로 평가(좋음/보통/나쁨)를 받습니다',
  'admin.ai.showSources': '출처 표시',
  'admin.ai.showSourcesDesc': '응답에 데이터 소스 및 시장 데이터에 대한 참조 표시',
  'admin.ai.hidePreview': '미리보기 숨기기',
  'admin.ai.showPreview': '미리보기 표시',
  'admin.ai.aiBehavior': 'AI 동작',
  'admin.ai.length': '길이',
  'admin.ai.liveExample': '라이브 예시',
  'admin.ai.testSettings': '설정 테스트',
  'admin.ai.selectExampleQuestion': '예시 질문 선택:',
  'admin.ai.userAsks': '사용자 질문:',
  'admin.ai.generating': 'AI가 응답 생성 중...',
  'admin.ai.generateExample': '예시 응답 생성',
  'admin.ai.aiResponds': 'AI 어시스턴트 응답:',
  'admin.ai.generateHint': '"예시 응답 생성"을 클릭하여 설정으로 AI가 어떻게 응답하는지 확인하세요.',
  'admin.ai.reset': '초기화',
  'admin.ai.saved': '저장됨!',
  'admin.ai.saveSettings': '설정 저장',

  // --- Table headers ---
  'admin.coupons.code': '코드',
  'admin.coupons.credits': '크레딧',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': '고품질의 균형 잡힌 분석. 대부분의 틈새 평가 및 아이디어 검증에 가장 적합합니다.',
  'admin.ai.model.preciseAnalyses': '정밀한 분석',
  'admin.ai.model.bestBalance': '최고의 균형',
  'admin.ai.model.recommended': '권장됨',
  'admin.ai.model.fastDesc': '빠른 틈새 확인, 브레인스토밍 및 초기 평가를 위한 초고속 응답. 속도가 중요할 때 이상적입니다.',
  'admin.ai.model.fast': '빠름',
  'admin.ai.model.fastestResponses': '가장 빠른 응답',
  'admin.ai.model.thinkingDesc': '고급 논리적 사고를 통한 심층 분석. 복잡한 시장 분석, 비판적 평가 및 전략적 계획에 적합합니다.',
  'admin.ai.model.deepestAnalysis': '가장 깊은 분석',
  'admin.ai.model.logicalThinking': '논리적 사고',
  'admin.ai.model.strategy': '전략',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': '엄격한 분석',
  'admin.ai.preset.strict.desc': '비판적, 사실 기반, 포장 없음. 약점을 무자비하게 드러냅니다.',
  'admin.ai.preset.extreme.name': '극단적 분석',
  'admin.ai.preset.extreme.desc': '최대 엄격함, 무자비한 비판, 최악의 시나리오 중심. 강력한 현실 점검에만 적합합니다.',
  'admin.ai.preset.professional.name': '전문가',
  'admin.ai.preset.professional.desc': '객관적, 구조화, 균형 잡힘. 경험 많은 비즈니스 컨설턴트와 같습니다.',
  'admin.ai.preset.realistic.name': '현실적',
  'admin.ai.preset.realistic.desc': '정직하고 실용적. 실행 가능한 구현과 실제 시장 데이터에 초점.',
  'admin.ai.preset.creative.name': '창의적 및 동기 부여',
  'admin.ai.preset.creative.desc': '영감을 주고, 아이디어가 풍부하며, 긍정적. 기회와 비전통적인 경로를 찾습니다.',
  'admin.ai.preset.balanced.name': '균형 잡힘',
  'admin.ai.preset.balanced.desc': '비판과 동기 부여의 좋은 균형. 기본 모드입니다.',
  'admin.ai.preset.investor.name': '투자자 관점',
  'admin.ai.preset.investor.desc': '벤처 캐피탈리스트처럼. 확장, ROI 및 출구 전략에 초점.',
  'admin.ai.preset.startup-coach.name': '스타트업 코치',
  'admin.ai.preset.startup-coach.desc': '창업자를 위한 실용적인 멘토. 빠른 구현 및 MVP에 초점.',
  'admin.ai.preset.market-researcher.name': '시장 조사자',
  'admin.ai.preset.market-researcher.desc': '데이터 기반 및 분석적. 심층 시장 및 경쟁 분석.',
  'admin.ai.preset.risk-analyst.name': '위험 분석가',
  'admin.ai.preset.risk-analyst.desc': '위험 및 최악의 시나리오에 초점. 현실적인 계획을 위해.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': '시장 분석',
  'admin.ai.focus.wettbewerb': '경쟁',
  'admin.ai.focus.monetarisierung': '수익화',
  'admin.ai.focus.risiken': '위험',
  'admin.ai.focus.finanzen': '재무',
  'admin.ai.focus.skalierung': '확장',
  'admin.ai.focus.innovation': '혁신',
  'admin.ai.focus.trends': '트렌드',
  'admin.ai.focus.differenzierung': '차별화',
  'admin.ai.focus.umsetzung': '구현',
  'admin.ai.focus.zielgruppe': '대상 고객',
  'admin.ai.focus.marketing': '마케팅',

  // --- Tone Options ---
  'admin.ai.tone.direkt': '직설적 & 날카롭게',
  'admin.ai.tone.professionell': '전문적 & 객관적',
  'admin.ai.tone.ehrlich': '정직 & 실용적',
  'admin.ai.tone.motivierend': '동기 부여 & 긍정적',
  'admin.ai.tone.freundlich': '친근 & 지지적',
  'admin.ai.tone.akademisch': '학문적 & 분석적',

  // --- Example Questions ---
  'admin.ai.question.niche': '어떤 수익성 있는 틈새 시장을 추천하시나요?',
  'admin.ai.question.evaluate': '제 아이디어를 평가해주세요: 반려견 주인을 위한 앱',
  'admin.ai.question.trends': '현재 잠재력이 있는 트렌드는 무엇인가요?',
  'admin.ai.question.sharpen': '내 틈새 시장을 어떻게 개선할 수 있나요?',

  'admin.ai.rec.bestCombination.title': '🏆 최고의 조합 (2개 프리셋)',
  'admin.ai.rec.bestCombination.desc': '비판적이지만 건설적, 구체적인 실행 단계 포함',
  'admin.ai.rec.bestCombination.useCase': '대부분의 분석에 권장',

  'admin.ai.rec.balancedThree.title': '⚖️ 균형 잡힘 (3개 프리셋)',
  'admin.ai.rec.balancedThree.desc': '전문적, 현실적, 투자자 친화적',
  'admin.ai.rec.balancedThree.useCase': '종합적인 비즈니스 분석용',

  'admin.ai.rec.creativeDriven.title': '💡 창의적 & 동기 부여 (2개 프리셋)',
  'admin.ai.rec.creativeDriven.desc': '실용적인 구현 팁과 함께 영감 제공',
  'admin.ai.rec.creativeDriven.useCase': '아이디어 구상 및 브레인스토밍용',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': '메뉴 열기',
  'header.home': '홈',
  'header.notifications': '알림',
  'header.settings': '설정',
  'header.profile': '프로필',
  'sidebar.collapse': '사이드바 접기',
  'sidebar.expand': '사이드바 펼치기',
  'sidebar.close': '메뉴 닫기',
  'sidebar.plan': '플랜',
  'sidebar.backToWebsite': '웹사이트로 돌아가기',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': '다시 오신 것을 환영합니다',
  'overview.greetingSub': '판결 데스크의 최신 상황입니다.',
  'overview.heroCta': '새 판결',
  'overview.currentPlan': '현재 플랜',
  'overview.creditsLabel': '크레딧',
  'overview.usedThisCycle': '이번 주기 사용',
  'overview.resetsOn': '재설정일',
  'overview.unlimitedTitle': '무제한',
  'overview.builderPerk': '전체 Builder 액세스 권한 — 제한 없음.',
  'overview.runOne': '판결 실행',
  'overview.lastVerdicts': '최근 5개 판결',
  'overview.noActivity': '아직 판결이 없습니다 — 첫 분석을 시작하세요',
  'overview.tipTitle': '팁',
  'overview.tipBody': '아이디어를 두 가지 언어로 테스트하세요 — 판결이 한쪽에서 부드러워지면, 당신의 가정은 보편적이지 않고 지역적입니다.',
  'onboard.skip': "건너뛰기",
  'onboard.cta.next': "다음",
  'onboard.cta.start': "시작하기",
  'onboard.s1.title': "IdeaVerdict에 오신 것을 환영합니다",
  'onboard.s1.body': "만들기 전에, 당신의 사업 아이디어에 대한 AI의 판결.",
  'onboard.s2.title': "가차 없이 솔직한 판결",
  'onboard.s2.body': "과장도, 아첨도 없다. 진짜 시장 데이터, 진짜 경쟁자, 진짜 리스크.",
  'onboard.s3.title': "빌더 리포트 PDF",
  'onboard.s3.body': "아키텍처, 재무, 시장 진입 전략을 담은 25~75페이지 리포트 생성.",
  'onboard.s4.title': "준비됐을 때 시작",
  'onboard.s4.body': "가입하고 1분 안에 첫 판결을 받아라.",
  'builderReport.title': "빌더 리포트 생성 중",
  'builderReport.subtitle': "종합 분석 + 개발자 브리핑 ― 완료 시 PDF로 다운로드.",
  'builderReport.idea': "당신의 아이디어",
  'builderReport.ideaPlaceholder': "사업 아이디어를 입력(비워두면 직전에 논의한 아이디어 사용)…",
  'builderReport.cta': "리포트 생성",
  'builderReport.credits': "크레딧",
  'builderReport.deductedNow': "성공 시 차감",
  'builderReport.dontClose': "이 창을 닫지 말 것 ― 생성에 30~90초 걸린다.",
  'builderReport.done': "PDF 다운로드 완료 ― 다운로드 폴더 확인.",
  'builderReport.failed': "생성 실패",
  'builderReport.close': "닫기",
  'builderReport.cancel': "취소",
  'builderReport.running': "생성 중…",
  'builderReport.retry': "재시도",
  'builderReport.unknownError': "생성 실패. 크레딧은 환불된다.",
  'builderReport.signInRequired': "리포트 생성에는 로그인이 필요하다.",
  'builderReport.ideaRequired': "AI가 분석할 수 있게 아이디어를 입력하라.",
  'builderReport.fromChat': "현재 대화에서",
  'builderReport.noIdeaDetected': "지금까지 논의한 아이디어 사용.",
  'builderReport.contextHint': "AI는 이 채팅의 모든 내용을 사용한다 ― 새 아이디어를 만들지 않는다.",
  'builderReport.step.core': "핵심 분석 생성 중",
  'builderReport.step.market': "확장 시장 분석 추가 중",
  'builderReport.step.tech': "기술 아키텍처 추가 중",
  'builderReport.step.financials': "재무 모델 추가 중",
  'builderReport.step.compet': "경쟁 인텔리전스 추가 중",
  'builderReport.step.gtm': "시장 진입 전략 추가 중",
  'builderReport.step.deepdive': "산업 심층 분석 추가 중",
  'builderReport.step.pdf': "PDF 편성 중…",
  'briefing.title': "개발자 브리핑 생성 중",
  'briefing.subtitle': "11개 섹션 기술 브리핑 ― 완료 시 PDF로 다운로드.",
  'briefing.ideaPlaceholder': "사업 아이디어를 입력(비워두면 직전에 논의한 아이디어 사용)…",
  'briefing.cta': "브리핑 생성",
  'briefing.step.core': "개발자 브리핑 생성 중",
  'briefing.step.pdf': "PDF 편성 중…",
  'pricing.gold.name': "골드",
  'pricing.gold.description': "크레딧 증가 + 50페이지 리포트",
  'pricing.gold.credits': "월 12,500 크레딧",
  'pricing.platinum.name': "플래티넘",
  'pricing.platinum.description': "최상위 티어 + 75페이지 리포트",
  'pricing.platinum.credits': "월 15,000 크레딧",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ko" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "크레딧 {{count}}개만 남음!",
  'trial.upgradeNow': "지금 업그레이드",
  'trial.upgradeNowArrow': "지금 업그레이드 →",
  'trial.creditsExhausted': "크레딧 소진",
  'trial.upgradeForUnlimited': "업그레이드해 무제한 이용",
  'trial.noCreditsPlaceholder': "남은 크레딧 없음…",
  'hero.badgeHonest': "솔직하고 편향 없는 AI",
  'hero.badge60sec': "60초 안에 판결",
  'hero.badge20Lang': "20개 이상 언어",
  'hero.widget.label': "아이디어 판결",
  'hero.widget.passed': "통과",
  'hero.widget.demoIdea': "의대생용 AI 튜터",
  'hero.widget.market': "시장",
  'hero.widget.demand': "수요",
  'hero.widget.competition': "경쟁",
  'hero.widget.verdictReady': "판결 완료 · 47초",
  'hero.widget.riskFlagged': "리스크 감지",
  'hero.widget.crowdedMarket': "포화 시장 · 기존 4개사",
  'hero.widget.suggestedPivot': "권장 피벗",
  'hero.widget.nicheBySpecialty': "전문 분야 니치화",
  'hero.widget.feasibilityGain': "실현 가능성 +38%",
  'hero.widget.analysisDone': "분석 완료",
  'hero.widget.metrics56': "6개 지표 중 5개",
  'hero.stats.verdictSpeed': "판결 속도",
  'cta.badge': "60초 안에 판결",
  'cta.subtitleEnd': "추측 없이.",
  'cta.signinPrompt': "계정 있음? 로그인",
  'cta.trustTrial': "7일 무료 체험",
  'cta.trustNoCard': "카드 불필요",
  'cta.trustCancel': "언제든 해지",
  'footer.themeLabel': "테마:",
  'footer.lightMode': "라이트 모드",
  'footer.darkMode': "다크 모드",
  'footer.sectionProduct': "제품",
  'footer.sectionLegal': "법적 고지",
  'nav.switchLight': "라이트 모드로 전환",
  'nav.switchDark': "다크 모드로 전환",
  'features.badge': "왜 IdeaVerdict인가",
  'features.mainFeatureLabel': "핵심 기능",
  'chatError.planRestriction': "이 기능은 더 높은 플랜이 필요합니다.",
  'chatError.creditDeduction': "결제 처리에 실패했습니다. 다시 시도해 주세요.",
  'chatError.aiService': "AI 서비스를 일시적으로 사용할 수 없습니다. 크레딧이 차감되지 않았습니다. 다시 시도해 주세요.",
  'chatError.parseError': "예상치 못한 응답 형식을 받았습니다. 다시 시도해 주세요.",
  'chatError.sessionExpired': "세션이 만료되었습니다. 다시 로그인해 주세요.",
  'chatError.timeout': "요청 시간이 너무 길어졌습니다. 다시 시도해 주세요.",
  'chatError.generic': "응답을 받지 못했습니다. 다시 시도해 주세요.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ko" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "크레딧 {{count}}개만 남음!",
  'trial.outOfCredits': "크레딧 소진",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "포화 시장 · 기존 4개사",
  'hero.widget.nicheBySpec': "전문 분야 니치화",
  'hero.widget.feasibilityUp': "실현 가능성 +38%",
  'hero.widget.fiveOfSix': "6개 지표 중 5개",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25페이지 Builder Report",
  'pricing.gold.report': "50페이지 Builder Report",
  'pricing.platinum.report': "75페이지 Builder Report",
  'auth.bestValue': "최고의 가치",
  'auth.elite': "엘리트",
  'builderReport.friendlyError': "이번에는 보고서를 완료하지 못했습니다. 크레딧이 차감되지 않았습니다 — 잠시 후 다시 시도해 주세요.",
  'builderReport.persistHint': "이 문제가 계속되면 support@ideaverdict.ai로 문의해 주세요.",
};
